module.exports = __webpack_public_path__ + "media/27.c83e351a.mp3";